<template>
  <div class="index bg1">
    <video autoplay loop id="video1" muted>
      <source src="../../assets/img/video.mp4" type="video/mp4" />
    </video>

    <div
      id="topnav"
      class="topnav f-absolute f-pt-l-n f-pt-r-n f-pt-t-n f-p-l-md f-p-r-md"
      style="z-index: 9;background-color:rgba(0,41,87,1);"
    >
      <div class="layui-header layui-row f-h-80 topbg">
        <div
          class="layui-col-3 f-h-80 layui-canvas-nav f-p-t f-p-b-xmd layui-row f-relative topbg03"
          style="padding-right: 100px;"
        >
          <div class="iconfont f-lh-40 f-pt-l-n f-left f-m-r">
            <i
              class="iconfont f-lh-40 f-color-41abeb f-size-30 f-mcp f-m-r"
              id="navbtn"
              @click="showNav"
            >&#xe620;</i>
            <router-link to="/home">
              <a class="iconfont f-lh-40 f-color-41abeb f-size-30 f-relative f-pt-t-xxss">&#xe746;</a>
            </router-link>
            <!-- <a class="iconfont f-lh-40 f-color-41abeb f-size-30 f-relative f-pt-t-xxss" href="/">&#xe746;</a> -->
            <i
              class="iconfont f-lh-40 f-color-41abeb f-size-38 f-mcp f-m-l-xls f-relative f-pt-t-xxs goback"
              onclick="backUp()"
              title="返回上一级"
              style="display: none"
            >&#xe6ca;</i>
          </div>
          <div
            class="f-p-r-sm f-p-l-sm f-lh-36 f-info-c f-color-b5dfff f-size-14r layui-nav-list f-left"
            style="min-width: 100px"
            id="nav-list"
          >{{navText}}</div>
        </div>
        <div class="layui-col-6 f-h-80 f-relative">
          <div class="f-absolute-all layui-canvas-title f-minus-l-xxl f-minus-r-xxl">
            <div id="font36" class="f-color-white f-info-c zwname f-size-36r">工业经济监测平台</div>
          </div>
        </div>
        <div
          id="f-right-bg"
          class="layui-col-3 f-h-80 layui-canvas-nav f-p-t f-p-b-xmd f-lh-40"
          layui-front="false"
          style="padding-left: 100px;"
        >
          <div class="f-right f-h-full f-p-t-sm f-m-r-sm">
            <div class="layui-form f-relative f-w-100 f-lh-22 datebox layui-input date f-b-n f-mcp">
              <i class="layui-icon f-absolute">&#xe625;</i>
              <!-- <input class="layui-input date f-b-n f-mcp" readonly type="text" id="date"> -->
              <el-date-picker
                class="dataStyle"
                :editable="false"
                :clearable="false"
                prefix-icon=" "
                v-model="dateValue"
                size="mini"
                type="month"
                format="yyyy-MM"
                :placeholder="yearmonth"
                @change="getMonthMy()"
              ></el-date-picker>
            </div>
          </div>
          <div class="f-right">
            <span class="f-color-b5dfff f-left f-size-14r f-m-r-sm" id="currentDate">{{curDateTime}}</span>
            <span class="f-color-b5dfff f-left f-size-14r f-m-r-sm" id="currentWeek">{{weekday}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 导航栏部分 -->
    <el-collapse-transition>
      <div class="navBox navbarbox" v-show="show">
        <ul class="navbar">
          <li v-for="(v,k) in navList" @click="toggleTabs(k)" :key="k">
            <router-link :to="v.url" replace :class="{active:router_path==v.url}">
              <a class="navbar-zwname f-webkit-box f-box-space-between">
                <span>{{v.name[0]}}</span>
                <span>{{v.name[1]}}</span>
              </a>
            </router-link>
          </li>
        </ul>
      </div>
    </el-collapse-transition>

    <!-- 路由组件入口 -->
    <router-view @getYearMonth="getYearMonth" :searchYearMonth="searchYearMonth"></router-view>
  </div>
</template>

<script>
import Bus from "./bus.js";
export default {
  name: "index",
  components: {},
  data() {
    return {
      navList: [
        {
          url: "/areavue",
          name: ["区", "域"],
          text: "区域",
        },
        {
          url: "/industry",
          name: ["行", "业"],
          text: "行业",
        },
        {
          url: "/garden",
          name: ["园", "区"],
          text: "园区",
        },
        {
          url: "/project",
          name: ["项", "目"],
          text: "项目",
        },
      ],
      navText: "区域",
      router_path: "/areavue",
      show: false,
      dateValue: "",
      curDateTime: "2020年04月10日",
      weekday: "星期五",
      yearmonth: "",
      searchYearMonth: "",
    };
  },

  created() {
    this.getCurrentDateTime();
    Bus.$on("valdd", (data) => {
      this.navText = data.name;
      this.router_path = data.path;
    });
  },

  mounted() {
    this.getRouterPath();
    // this.getCurrentDateTime();
  },

  methods: {
    getYearMonth(value) {
      console.error(value);
    },
    /*控制菜单显示隐藏开始*/
    showNav() {
      this.show = !this.show;
    },
    /*控制菜单显示隐藏结束*/

    //获取当前页面路由 开始
    getRouterPath() {
      let routerpath = this.$route.path;
      if (routerpath == "/areaSon") {
        this.router_path = "/areavue";
      } else {
        this.router_path = routerpath;
      }

      for (var i = 0; i < this.navList.length; i++) {
        if (this.navList[i].url == routerpath) {
          this.navText = this.navList[i].text;
        }
      }
    },
    //获取当前页面路由 结束
    //导航栏active 开始
    toggleTabs: function (index) {
      this.router_path = this.navList[index].url;
      this.navText = this.navList[index].text;
      this.show = false;
    },
    //导航栏active 结束
    /*获取当前时间开始*/
    getCurrentDateTime() {
      var d = new Date();
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var date = d.getDate();
      var week = d.getDay();
      var curDateTime = year;

      if (month > 9) {
        curDateTime = curDateTime + "年" + month;
        this.yearmonth = year + "-" + month;
      } else {
        curDateTime = curDateTime + "年0" + month;
        this.yearmonth = year + "-0" + month;
      }

      if (date > 9) curDateTime = curDateTime + "月" + date + "日";
      else curDateTime = curDateTime + "月0" + date + "日";
      var weekday = "";
      if (week == 0) weekday = "星期日";
      else if (week == 1) weekday = "星期一";
      else if (week == 2) weekday = "星期二";
      else if (week == 3) weekday = "星期三";
      else if (week == 4) weekday = "星期四";
      else if (week == 5) weekday = "星期五";
      else if (week == 6) weekday = "星期六";
      this.curDateTime = curDateTime;
      this.weekday = weekday;
      this.searchYearMonth = this.yearmonth;
    },
    /*获取当前时间结束*/

    /*选择月份开始*/
    getMonthMy() {
      var d = new Date(this.dateValue);
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      Bus.$emit("dateVal", { val: year + "-" + month });
      this.yearmonth = year + "-" + month;
      this.searchYearMonth = this.yearmonth;
    },
    /*选择月份结束*/
  },
};
</script>

<style scoped>
@import "../../assets/css/iconfont.css";
@import "../../assets/css/layui.css";
@import "../../assets/css/skin.css";
@import "../../assets/css/base.css";

.index {
  height: 100%;
}

#routerlink {
  position: fixed;
  top: 100px;
  left: 60px;
  color: #fff;
}

#divrouter {
  position: fixed;
  top: 240px;
  left: 50px;
  color: #fff;
}

.navBox {
  position: fixed;
  top: 80px;
  left: 0;
  bottom: 0;
  z-index: 999;
}

#font36 {
  font-size: 36px;
  letter-spacing: 20px;
}

#topnav {
  padding: 0 20px;
}

#video1 {
  opacity: 0.5;
}

.topbg {
  background: url(../../assets/img/topbg.png) center no-repeat;
  background-size: 100% 100%;
}

#f-right-bg {
  background: url(../../assets/img/topbg01.png) center no-repeat;
  background-size: 100% 100%;
}

.f-minus-r-xxl {
  background: url(../../assets/img/topbg02.png) center no-repeat;
  background-size: 100% 100%;
}

.topbg03 {
  background: url(../../assets/img/topbg03.png) center no-repeat;
  background-size: 100% 100%;
}

#nav-list {
  background: url(../../assets/img/trade001.png) center no-repeat;
  background-size: 100% 100%;
}

.el-input--mini .el-input__inner {
  line-height: 22px !important;
  height: 22px !important;
}

input.el-input__inner {
  background-color: rgba(0, 0, 0, 0);
}

.el-date-editor.el-input {
  display: inline;
  padding: 1px 2px;
}

.el-date-editor.el-input >>> .el-input__inner {
  padding: 0;
  background: rgba(0, 0, 0, 0);
  line-height: 22px;
  height: 22px;
  border: 0;
  color: #000;
  cursor: pointer;
}

.el-input__inner {
  background-color: rgba(255, 000, 000, 0.6);
}

.el-picker-panel {
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>